import React from 'react';

const Signup = props => (
  <svg viewBox="0 0 80 73.28" {...props}>
    <path d="M1.01 31.6a1.9 1.9 0 000 3.36l27.9 10.76L77.31.01zm28.91 17.14V71.6a1.8 1.8 0 001.68 1.68 1.75 1.75 0 001.34-.67l11.14-18.83 20.17 11.09a1 1 0 001.34 0l1-1L80.04 2.36z" />
  </svg>
);

export default Signup;
